<template>
  <div
    id="panel"
    class="panel"
  >
    <div class="panel-title">
      <p>实验管理</p>
    </div>
    <div class="panel-content center_content">
      <div id="searchSection">
        <div class="search-line clearfix">
          <select
            class="s-select separate"
            v-model="queryInfo.exp_level"
          >
            <option value="">请选择申报级别</option>
            <option
              :value="key"
              v-for="(val, key) in expLevelData"
              :key="key"
            >{{ val }}</option>
          </select>
          <select
            class="s-select separate"
            v-model="queryInfo.auth_exp_level"
          >
            <option value="">请选择获奖等级</option>
            <option
              :value="key"
              v-for="(val, key) in authExpLevelData"
              :key="key"
            >{{ val }}</option>
          </select>
          <select
            :disabled="[2,3,4,10,11,12].indexOf(localUser.role) >= 0"
            class="s-select separate"
            v-model="queryInfo.province"
            @change="searchSchool(queryInfo.province, 1)"
          >
            <option value="">选择省份</option>
            <option
              :value="key"
              v-for="(val, key) in provinceData"
              :key="key"
            >{{ val }}</option>
          </select>
          <select
            :disabled="[3,4,11,12].indexOf(localUser.role) >= 0"
            class="s-select separate"
            v-model="queryInfo.school_id"
            @change="searchAcademy(queryInfo.school_id, 1)"
          >
            <option value="">选择学校</option>
            <option
              :value="item.id"
              v-for="item in searchSchoolData"
              :key="item.id"
            >{{item.title}}</option>
          </select>
          <select
            :disabled="[4,11,12].indexOf(localUser.role) >= 0"
            class="s-select separate"
            v-model="queryInfo.academy_id"
          >
            <option value="">选择学院</option>
            <option
              :value="item.id"
              v-for="item in searchAcademyData"
              :key="item.id"
            >{{item.title}}</option>
          </select>
          <select
            class="s-select separate"
            v-model="queryInfo.subject_category_id"
            @change="searchSubject(queryInfo.subject_category_id, 1)"
          >
            <option value="">请选择专业大类</option>
            <option
              :value="item.id"
              v-for="item in searchCategoryData"
              :key="item.id"
            >{{item.title}}</option>
          </select>
          <select
            class="s-select separate"
            v-model="queryInfo.subject_id"
          >
            <option value="">请选择专业</option>
            <option
              :value="item.id"
              v-for="item in searchSubjectData"
              :key="item.id"
            >{{item.title}}</option>
          </select>
        </div>
        <div class="search-line clearfix">
          <select
            class="s-select separate"
            v-model="queryInfo.status"
          >
            <option value="">请选择状态</option>
            <option
              :value="key"
              v-for="(val, key) in experimentStateDict"
              :key="key"
            >{{ val }}</option>
          </select>
          <input
            type="text"
            placeholder="实验名称"
            class="s-input separate"
            v-model="queryInfo.title"
          >
          <input
            type="text"
            placeholder="负责人"
            class="s-input separate"
            v-model="queryInfo.master_name"
          >
          <input
            type="button"
            value="搜索"
            class="s-btn"
            @click="pageCallback(1)"
          >
        </div>
        <hr>
        <div class="search-line search-line-btn clearfix">
          <ul class="year-list">
            <span>申报年份：</span>
            <li
              :class="queryInfo.apply_year==''?'active':''"
              @click="queryInfo.apply_year='',search()"
            >全部</li>
            <li
              v-for="item in yearData"
              :key="item"
              :class="queryInfo.apply_year==item?'active':''"
              @click="queryInfo.apply_year=item,search()"
            >{{item}}</li>
          </ul>
          <div>
            <div
              class="add-btn"
              @click="showAddWindow"
            >新建</div>
            <div
              class="add-btn export-btn"
              @click="exportMember"
            >导出</div>
<!--            <div-->
<!--              class="add-btn"-->
<!--              id="batchUpload"-->
<!--              @click="showUploadWindow"-->
<!--            >-->
<!--              修改有效链接-->
<!--            </div>-->
          </div>
        </div>
      </div>
      <div id="list">
        <table v-if="tableData.length">
          <tbody>
            <tr class="l_header">
              <th class="itemStatus">实验名称</th>
              <th class="itemStatus">申报级别</th>
              <th class="itemStatus">省份</th>
              <th class="itemStatus">学校</th>
              <th class="itemStatus">学院</th>
              <th class="itemStatus">对应专业大类</th>
              <th class="itemStatus">对应专业</th>
              <th class="itemStatus">申报年份</th>
              <th class="itemStatus">负责人</th>
              <th class="itemStatus">创建人</th>
              <th class="itemStatus">状态</th>
              <th
                class="action"
                width="160"
              >操作</th>
            </tr>
            <tr
              class="item"
              v-for="item in tableData"
              :key="item.id"
            >
              <td class="itemStatus">
                <router-link
                  class="a-link"
                  to=""
                >{{item.title}}</router-link>
              </td>
              <td class="itemStatus">{{formatExpLevel(item.exp_level)}}</td>
              <td class="itemStatus">{{formatProvince(item.province)}}</td>
              <td class="itemStatus">{{item.school_title ? item.school_title : ''}}</td>
              <td class="itemStatus">{{item.academy_title ? item.academy_title : ''}}</td>
              <td class="itemStatus">{{item.sc_title}}</td>
              <td class="itemStatus">{{item.s_title}}</td>
              <td class="itemStatus">{{item.apply_year?item.apply_year:'--'}}</td>
              <td class="itemStatus">{{item.master_name?item.master_name: '--'}}</td>
              <td class="itemStatus">{{item.creator_name ? item.creator_name : '--'}}</td>
              <td
                class="itemStatus"
                :class="[1, 8].indexOf(item.status)>= 0 ? 'itemStatus0':item.status==9 ? 'itemStatus4':[2, 4, 6].indexOf(item.status) >= 0 ? 'itemStatus1' : ''"
              >
                {{ experimentStateDict[item.status] }}
              </td>
              <td class="action">
                <router-link
                  class="see"
                  :to="'/www/experiment?id=' + item.id"
                >预览</router-link>
                <router-link
                  v-if="isSuper || (audit_open == 1 && [1,3].indexOf(item.status) >= 0)"
                  class="set"
                  :to="'/admin/experiment_maintain?id=' + item.id"
                >管理</router-link>
                <a
                  class="modify"
                  href="javascript:;"
                  @click="showPersonWindow(item)"
                >负责人</a>
                <a
                  v-if="isSuper || (audit_open && item.status==1)"
                  class="edit"
                  href="javascript:;"
                  @click="querySingle(item.id)"
                >编辑</a>
                <a
                  class="delete"
                  href="javascript:;"
                  @click="askDel(item.id)"
                  v-if="isSuper"
                >删除</a>

                <a
                  :class="item.status==8?'publish':'nopublish'"
                  href="javascript:;"
                  v-if="item.status==8 || item.status==9"
                  @click="askRelease(item)"
                >
                  {{item.status==8?'发布' : '取消发布'}}
                </a>
                <a
                  class="publish"
                  href="javascript:;"
                  v-if="[2,5].indexOf(item.status) >= 0 && localUser.role == 4"
                  @click="showExamineWindow(item.id, item.status)"
                  title="院系管理员审核"
                >院系管理员审核</a>
                <a
                  class="publish"
                  href="javascript:;"
                  v-if="[4,7].indexOf(item.status) >= 0 && localUser.role == 3"
                  @click="showExamineWindow(item.id, item.status)"
                  title="校管理员审核"
                >校管理员审核</a>
                <a
                  class="publish"
                  href="javascript:;"
                  v-if="[6].indexOf(item.status) >= 0 && localUser.role == 2"
                  @click="showExamineWindow(item.id, item.status)"
                  title="省管理员审核"
                >省管理员审核</a>
                <a
                  class="nopublish"
                  href="javascript:;"
                  v-if="audit_open == 1 && isSuper && item.status >=2 && item.status <=8"
                  @click="Editable(item.id)"
                >返回负责人编辑</a>
                <a
                  class="color1"
                  v-if="audit_open == 0 && isSuper"
                  href="javascript:;"
                  @click="showExplevelWindow(item)"
                >修改申报级别</a>
                <a
                  class="color2"
                  v-if="audit_open == 0 && isSuper"
                  href="javascript:;"
                  @click="showDeclareWindow(item)"
                >修改申报状态</a>
              </td>
            </tr>
          </tbody>
        </table>
        <div
          class="noitems"
          v-else
        >没有数据</div>
      </div>
      <!-- 分页 -->
      <pagination
        :cur='pageInfo.page'
        :all='pageInfo.all'
        :totalData="pageInfo.totalData"
        :callback="pageCallback"
      ></pagination>
      <!-- 用户添加/编辑弹窗 -->
      <div
        class="form_overlay"
        :style="classShowAddWindow"
      >
        <div class="form_overlay_bg"></div>
        <div class="form_panel">
          <div class="form_title">实验管理</div>
          <div class="form_content">
            <form>
              <div class="item">
                <span class="label"><i class="require">*</i>实验名称:</span>
                <input
                  v-model="formInfo.title"
                  type="text"
                  autocomplete="off"
                  maxlength="25"
                >
              </div>
              <div class="item">
                <span class="label"><i class="require">*</i>申报级别:</span>
                <select v-model="formInfo.exp_level">
                  <option value="">选择申报级别</option>
                  <option
                    :value="key"
                    v-for="(val, key) in expLevelData"
                    :key="key"
                  >{{ val }}</option>
                </select>
              </div>
              <div class="item">
                <span class="label"><i class="require">*</i>省份:</span>
                <select
                  :disabled="[2,3,4,10,11,12].indexOf(localUser.role) >= 0"
                  v-model="formInfo.province"
                  @change="searchSchool(formInfo.province)"
                >
                  <option value="">选择省份</option>
                  <option
                    :value="key"
                    v-for="(val, key) in provinceData"
                    :key="key"
                  >{{ val }}</option>
                </select>
              </div>
              <div class="item">
                <span class="label"><i class="require">*</i>学校:</span>
                <select
                  v-model="formInfo.school_id"
                  @change="searchAcademy(formInfo.school_id)"
                  :disabled="[3,4,11,12].indexOf(localUser.role) >= 0"
                >
                  <option value="">选择学校</option>
                  <option
                    :value="item.id"
                    v-for="item in schoolData"
                    :key="item.id"
                  >{{item.title}}</option>
                </select>
              </div>
              <div class="item">
                <span class="label"><i class="require">*</i>学院:</span>
                <select
                  v-model="formInfo.academy_id"
                  :disabled="[4,11,12].indexOf(localUser.role) >= 0"
                >
                  <option value="">选择学院</option>
                  <option
                    :value="item.id"
                    v-for="item in academyData"
                    :key="item.id"
                  >{{item.title}}</option>
                </select>
              </div>
              <div class="item">
                <span class="label"><i class="require">*</i>专业大类:</span>
                <select
                  v-model="formInfo.subject_category_id"
                  @change="searchSubject(formInfo.subject_category_id)"
                >
                  <option value="">请选择专业大类</option>
                  <option
                    :value="item.id"
                    v-for="item in categoryData"
                    :key="item.id"
                  >{{item.title}}</option>
                </select>
              </div>
              <div class="item">
                <span class="label"><i class="require">*</i>专业:</span>
                <select v-model="formInfo.subject_id">
                  <option value="">请选择专业</option>
                  <option
                    :value="item.id"
                    v-for="item in subjectData"
                    :key="item.id"
                  >{{item.title}}</option>
                </select>
              </div>
              <div class="item">
                <span class="label"><i class="require">*</i>申报年份:</span>
                <select v-model="formInfo.apply_year">
                  <option value="">请选择申报年份</option>
                  <option
                    v-for="(item,index) in yearData"
                    :key="index"
                    :value="item"
                  >{{ item }}</option>
                </select>
              </div>
            </form>
          </div>
          <div class="form_control">
            <a
              href="javascript:;"
              class="button close"
              @click="hideAddWindow"
            >取消</a>
            <a
              href="javascript:;"
              class="button"
              @click="saveInfo"
            >提交</a>
          </div>
        </div>
      </div>
      <!-- 负责人弹窗 -->
      <div
        id="c-panel"
        :style="classShowPersonWindow"
      >
        <div id="c-panel-bg"></div>
        <div
          class="c-content"
          style=""
        >
          <form
            id="search"
            onsubmit="return false;"
          >
            <input
              type="text"
              class="s-text"
              v-model="userQueryInfo.username"
              placeholder="用户名"
              autocomplete="off"
            >
            <input
              type="text"
              class="s-text"
              v-model="userQueryInfo.name"
              placeholder="姓名"
              autocomplete="off"
            >
            <input
              type="submit"
              class="s-btn1"
              @click="pageCalluser(1)"
              value="查询"
            >
            <span
              class="close-cpanel"
              @click="hidePersonWindow"
            ></span>
          </form>
          <div id="uList">
            <table>
              <tbody>
                <tr class="l_header">
                  <th>用户名</th>
                  <th>姓名</th>
                  <th>性别</th>
                  <th>省份</th>
                  <th>学校</th>
                  <th>学院</th>
                  <th class="action">操作</th>
                </tr>
                <tr
                  class="item"
                  v-for="(item, index) in userData"
                  :key="index"
                >
                  <td>{{item.username}}</td>
                  <td>{{item.name}}</td>
                  <td>{{item.gender==1?'男': '女'}}</td>
                  <td>{{item.academy ? formatProvince(item.province) : '-'}}</td>
                  <td>{{item.school ? item.school.title : '-'}}</td>
                  <td>{{item.academy ? item.academy.title : '-'}}</td>
                  <td class="action">
                    <a
                      class="a-button"
                      v-if="item.id != selectedExperiment.master_id"
                      href="javascript:;"
                      @click="setMaster(item.id)"
                    >选择</a>
                    <span v-else>负责人</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- 分页 -->
          <pagination
            :cur='useInfo.page'
            :all='useInfo.all'
            :totalData="useInfo.totalData"
            :callback="pageCalluser"
          ></pagination>
        </div>
      </div>
      <!-- 设置级别 -->
      <div
        class="form_overlay"
        :style="classShowLevelWindow"
      >
        <div class="form_overlay_bg"></div>
        <div class="form_panel">
          <div class="form_title">申报级别</div>
          <div class="form_content">
            <form>
              <div class="item">
                <span class="label"><i class="require">*</i>申报级别:</span>
                <select v-model="formInfo.exp_level">
                  <option value="">请选择申报级别</option>
                  <option
                    :value="key"
                    v-for="(val, key) in expLevelData"
                    :key="key"
                  >{{ val }}</option>
                </select>
              </div>
            </form>
          </div>
          <div class="form_control">
            <a
              href="javascript:;"
              class="button close"
              @click="classShowLevelWindow={}"
            >取消</a>
            <a
              href="javascript:;"
              class="button"
              @click="saveLevel"
            >提交</a>
          </div>
        </div>
      </div>
      <!-- 审核 -->
      <div
        class="form_overlay"
        :style="classShowExamineWindow"
      >
        <div class="form_overlay_bg"></div>
        <div class="form_panel">
          <div class="form_title">实验审核</div>
          <div class="form_content">
            <form id="itemForm">
              <div class="item">
                <span class="label"><i class="require">*</i>审核结果:</span>
                <select v-model="examineInfo.status">
                  <option
                    v-for="item in auditExpLevel"
                    :value="item.value"
                    :key="item.value"
                  >{{ item.name }}</option>
                </select>
              </div>
            </form>
          </div>
          <div class="form_control">
            <a
              href="javascript:;"
              class="button close"
              id="form_close"
              @click="classShowExamineWindow={}"
            >取消</a>
            <a
              href="javascript:;"
              class="button"
              id="form_submit"
              @click="examineBtn"
            >提交</a>
          </div>
        </div>
      </div>
      <!-- 平台申报状态 -->
      <div
        class="form_overlay"
        :style="classShowAuditOpenWindow"
      >
        <div class="form_overlay_bg"></div>
        <div class="form_panel">
          <div class="form_title">设置申报状态</div>
          <div class="form_content">
            <form>
              <div class="item">
                <span class="label"><i class="require">*</i>平台申报:</span>
                <label>
                  <input
                    v-model="formAuditOpen.audit_open"
                    type="radio"
                    value="1"
                    checked="checked"
                  >申报开启</label>
                <label style="margin-left:10px">
                  <input
                    v-model="formAuditOpen.audit_open"
                    type="radio"
                    value="0"
                    checked="checked"
                  >关闭</label>
              </div>
            </form>
          </div>
          <div
            class="form_control"
          >
            <a
              href="javascript:;"
              class="button close"
              @click="hideAuditOpen"
            >取消</a>
            <a
              href="javascript:;"
              class="button"
              @click="saveAuditOpen"
            >提交</a>
          </div>
        </div>
      </div>
      <!-- 修改申报状态 -->
      <div
        class="form_overlay"
        :style="classShowDeclareWindow"
      >
        <div class="form_overlay_bg"></div>
        <div class="form_panel">
          <div class="form_title">设置申报状态</div>
          <div class="form_content">
            <form>
              <div class="item">
                <span class="label"><i class="require">*</i>申报状态:</span>
                <select v-model="declareInfo.sbStatus">
                  <option
                    :value="key"
                    v-for="(val, key) in sbStateDict"
                    :key="key"
                  >{{ val }}</option>
                </select>
              </div>
            </form>
          </div>
          <div class="form_control">
            <a
              href="javascript:;"
              class="button close"
              @click="classShowDeclareWindow={}"
            >取消</a>
            <a
              href="javascript:;"
              class="button"
              @click="saveDeclare"
            >提交</a>
          </div>
        </div>
      </div>
      <!-- 修改申报级别 -->
      <div
        class="form_overlay"
        :style="classShowExplevelWindow"
      >
        <div class="form_overlay_bg"></div>
        <div class="form_panel">
          <div class="form_title">设置申报级别</div>
          <div class="form_content">
            <form>
              <div class="item">
                <span class="label"><i class="require">*</i>申报级别:</span>
                <select v-model="ExpLevelInfo.exp_level">
                  <!--                  <option value="1">省级</option>-->
                  <!--                  <option value="2">院级</option>-->
                  <!--                  <option value="3">校级</option>-->
                  <option
                    :value="key"
                    v-for="(val, key) in expLevelData"
                    :key="key"
                  >{{ val }}</option>
                </select>
              </div>
            </form>
          </div>
          <div class="form_control">
            <a
              href="javascript:;"
              class="button close"
              @click="classShowExplevelWindow={}"
            >取消</a>
            <a
              href="javascript:;"
              class="button"
              @click="saveExplevel"
            >提交</a>
          </div>
        </div>
      </div>
      <!-- 批量修改链接 -->
      <div
        class="form_overlay"
        :style="classShowUploadWindow"
      >
        <div class="form_overlay_bg"></div>
        <div class="form_panel">
          <div class="form_title">批量上传</div>
          <div class="form_content">
            <form id="uploadForm">
              <div class="item">
                <span
                  class="label"
                  style="width: auto"
                >
                  <i class="require"></i>模版创建规则:
                </span>
                <div class="item-box divLabel gray">
                  <div class="normal-width">
                    <p>
                      1. 文件格式为常用的Excel文件（*.xls）；
                    </p>
                    <p>
                      2.填写导入数据时，需先删除导入模版中首行以下所有说明示例数据；
                    </p>
                    <p>
                      3.导入的数据总条数建议不超过500条，如超过，建议分多次导入；
                    </p>
                  </div>
                </div>
                <div class="clear"></div>
              </div>
              <div class="item">
                <div class="attachment" style="margin-left: 110px;">
                  <a
                    href="/static/upload_template/batch_edit_link_template.xls"
                    download="batch_edit_link_template.xls"
                    target="_blank"
                  >模版下载</a>
                </div>
                <div class="clear"></div>
              </div>
              <div class="item">
                <span
                  class="label"
                  style="width: auto"
                >
                  <i class="require">*</i>xls文件:
                </span>
                <div
                  class="item-box"
                  style="margin-left: 40px;"
                >
                  <input
                    v-model="uploadedCsv"
                    disabled
                    type="text"
                    id="fileUrl"
                    style="width: 225px"
                  />
                  <span
                    class="button"
                    style="position: relative; top: 0px; left: 0px"
                  >
                    选择文件
                    <input
                      @change="xlsChange"
                      type="file"
                      accept=".csv,.xls,.xlsx"
                      ref="xlsFile"
                      id="fileUpload"
                      class="upload-derict"
                    />
                  </span>
                </div>
                <div class="clear"></div>
              </div>
            </form>
          </div>
          <div class="form_control">
            <a
              href="javascript:;"
              style="width: 30px"
              class="button close"
              id="form_upload_close"
              @click="hideUploadWindow"
            >取消</a>
            <a
              href="javascript:;"
              style="width: 30px"
              class="button"
              id="form_upload_submit"
              @click="submitCsv"
            >提交</a>
          </div>
        </div>
      </div>
      <div
        id="dialog_overlay"
        :style="classShowProcessWindow"
      >
        <div id="dialog_bg"></div>
        <div
          id="dialog_panel"
          ref="refErrorList"
          style="margin-left: -136px; margin-top: -54px;max-width: 300px;"
        >
          <div id="dialog_panel_bg"></div>
          <div id="dialog_title">提示</div>
          <div id="dialog_content">
            ({{ curCsvIndex }} / {{ uploadedCscData.length }})
            <span style="color: #219d2b">
              {{ ' ' + csvFinishText }}
            </span>
          </div>
          <div id="dialog_content2">
            <ul>
              <li
                v-for="(item, index) in errorList"
                v-bind:key="index"
              >
                <span :class="item.code == 1 ? 'success' : 'fail'">{{ item.text }}</span>
              </li>
            </ul>

          </div>
          <div id="dialog_control">
            <a
              href="javascript:void(0)"
              id="dialog_ok"
              class="button col2"
              @click="classShowProcessWindow={}"
              :style="isFinishUpsert ? 'display: inline-block' : 'display:none'"
            >确认</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import outputTable from '../../../assets/basic/outputTable.js'
import Pagination from '../../../components/Pager'
export default {
  name: 'User',
  components: {
    Pagination
  },
  data() {
    return {
      searchSchoolData: [],
      searchAcademyData: [],
      searchCategoryData: [],
      searchSubjectData: [],
      classShowAddWindow: {},
      classShowAuditOpenWindow: {},
      classShowPersonWindow: {
        display: 'none'
      },
      classShowExamineWindow: {},
      classShowLevelWindow: {},
      classShowDeclareWindow: {},
      classShowExplevelWindow: {},
      tableData: [],
      schoolData: [],
      academyData: [],
      categoryData: [],
      subjectData: [],
      userQueryInfo: {
        page: 1,
        size: 10,
        school_id: '',
        username: '',
        name: '',
        role: 11
      },
      selectedExperiment: {},
      userData: [],
      userDataCount: '',
      queryInfo: {
        page: 1,
        size: 10,
        province: '',
        school_id: '',
        academy_id: '',
        subject_category_id: '',
        subject_id: '',
        exp_level: '',
        auth_exp_level: '',
        status: '',
        title: '',
        master_name: '',
        apply_year: ''
      },
      formInfo: {
        id: 0,
        title: '',
        exp_level: '',
        province: '',
        school_id: '',
        academy_id: '',
        subject_category_id: '',
        subject_id: '',
        creator_id: this.$store.state.userInfo.profile_id,
        apply_year: '',
        auth_exp_level: 4
      },
      examineInfo: {
        id: '',
        status: 4,
        current_status: 0
      },
      tableDataCount: 0,
      exportArray: [],
      exportData: [],
      audit_open: 0,
      globalSettingId: 0,
      formAuditOpen: {
        id: 0,
        audit_open: 1
      },
      declareInfo: {
        id: 0,
        sbStatus: ''
      },
      ExpLevelInfo: {
        id: 0,
        exp_level: ''
      },
      classShowUploadWindow: {},

      uploadedCsv: '',
      uploadedCscData: [],
      classShowProcessWindow: {},
      isFinishUpsert: false,
      curCsvIndex: 0,
      csvFinishText: '',
      errorList: [],
      isRepeat: false
    }
  },
  methods: {
    showExplevelWindow(item) {
      this.ExpLevelInfo.id = item.id
      this.ExpLevelInfo.exp_level = item.exp_level
      this.classShowExplevelWindow = {
        visibility: 'visible'
      }
    },
    showDeclareWindow(item) {
      this.declareInfo.id = item.id
      this.declareInfo.sbStatus = item.sbStatus
      this.classShowDeclareWindow = {
        visibility: 'visible'
      }
    },
    async saveExplevel() {
      const url = '/experiment/' + this.ExpLevelInfo.id + '/'
      await await this.$http.put(url, {
        exp_level: this.ExpLevelInfo.exp_level
      }).then((data) => {
        this.$layer.msg('修改成功')
        this.search()
        this.classShowExplevelWindow = {}
      }).catch(() => {
        this.$layer.msg('修改失败！')
      })
    },
    async saveDeclare() {
      const url = '/experiment/' + this.declareInfo.id + '/'
      await await this.$http.put(url, {
        sbStatus: this.declareInfo.sbStatus
      }).then((data) => {
        this.$layer.msg('修改成功')
        this.search()
        this.classShowDeclareWindow = {}
      }).catch(() => {
        this.$layer.msg('修改失败！')
      })
    },
    async checkAuditOpen () {
      await this.$http.get('/globalsetting/').then(async (data) => {
        if (data.results.length > 0) {
          this.audit_open = data.results[0].audit_open
          this.globalSettingId = data.results[0].id
        } else {
          this.audit_open = 1
          await this.$http.post('/globalsetting/', {
            audit_open: 1
          }).then((data) => {
            console.log(data)
            this.globalSettingId = data.id
          })
        }
      })
    },
    showAuditOpen () {
      this.formAuditOpen.id = this.globalSettingId
      this.formAuditOpen.audit_open = this.audit_open
      this.classShowAuditOpenWindow = {
        visibility: 'visible'
      }
    },
    hideAuditOpen () {
      this.classShowAuditOpenWindow = {}
    },
    async saveAuditOpen () {
      const url = '/globalsetting/' + this.formAuditOpen.id + '/'
      await this.$http.put(url, this.formAuditOpen).then((data) => {
        if (data.id) {
          this.$parent.showMsg('修改成功！')
          this.audit_open = this.formAuditOpen.audit_open
          this.hideAuditOpen()
        } else {
          this.$parent.showMsg('修改失败！')
        }
      }).catch((error) => {
        console.log(error)
        this.$parent.showMsg('修改失败！')
      })
    },
    async exportMember () {
      const params = JSON.parse(JSON.stringify(this.queryInfo))
      params.size = 10000

      this.exportArray = [{
        projId: '项目ID',
        title: '项目标题',
        declareYear: '申报年份',
        province: '省份',
        specialtySubject: '专业大类',
        specialtySubject2: '专业分类',
        projUrl: '项目地址',
        expUrl: '实验链接',
        schoolCode: '学校代码',
        incharge: '项目负责人',
        remarks: '备注',
        isZhen: '是/否',
        STATUS: '审核结果（省管理）',
        exp_level: '申报级别',
        status: '项目状态',
        schoolTitle: '学校名称',
        academyTitle: '学院名称',
        auth_exp_level: '获奖等级',
        auth_year: '获奖年份',
        // student_count: '实验人次',
        // completePeople: '实验完成人数',

        view_count: '浏览量',
        do_count: '实验人次',
        do_user: '实验人数',
        click_count: '实验点击量',
        avg_time: '实验平均用时',
        finish_percent: '实验完成率',
        pass_percent: '实验通过率',
        report_count: '实验报告数'
      }]
      await this.$http.get('/experiment_export/', { params }).then((data) => {
        if (data.code === '200') {
          this.exportData = data.data.results
          if (this.exportData.length === 0) {
            this.$layer.msg('暂无信息可导出！')
            return false
          } else {
            this.exportData.forEach(item => {
              this.exportArray.push({
                projId: item.id,
                title: item.title,
                declareYear: item.apply_year,
                province: this.formatProvince(item.province),
                specialtySubject: item.sc_title ? item.sc_title : '--',
                specialtySubject2: item.s_title ? item.s_title : '--',
                projUrl: 'http://123.56.121.49/www/experiment?id=' + item.id,
                expUrl: item.url,
                schoolCode: item.school_code ? item.school_code : '--',
                incharge: item.master_name ? item.master_name : '--',
                remarks: null,
                isZhen: item.double_lang ? '是' : '否',
                STATUS: item.status > 7 ? '通过' : (item.status === 7 ? '未通过' : ''),
                exp_level: this.formatExpLevel(item.exp_level),
                status: this.experimentStateDict[item.status],
                schoolTitle: item.school_title ? item.school_title : '--',
                academyTitle: item.academy_title ? item.academy_title : '--',
                auth_exp_level: this.authExpLevelData[item.auth_exp_level],
                auth_year: item.auth_year ? item.auth_year : '',
                // student_count: item.student_count,
                // completePeople: item.student_finish_count,

                view_count: item.view_count,
                do_count: item.do_count,
                do_user: item.do_user,
                click_count: item.click_count,
                avg_time: item.avg_time,
                finish_percent: item.finish_percent,
                pass_percent: item.pass_percent,
                report_count: item.report_count
              })
            })
            this.$layer.msg('导出成功')
            this.exportCsv()
          }
        } else {
          this.$layer.msg('获取实验信息失败！')
        }
      }).catch(() => {
        this.$layer.msg('获取信息失败！')
      })
    },
    exportCsv () {
      var fileName = '数据详情.csv'
      outputTable(this.exportArray, fileName)
      this.exportArray = []
    },
    formatExpLevel(level) {
      return this.$store.state.dict_exp_level[level]
    },
    formatProvince(province) {
      return this.$store.state.dict_province[province]
    },
    // 搜索
    async search() {
      if (parseInt(this.localUser.role) === 1) {
        this.queryInfo.academy_id = this.localUser.academy_id
      }
      await this.$http.get('/experiment_list/', {
        params: this.queryInfo
      }).then((data) => {
        if (data.code === '200') {
          this.tableData = data.data.results
          this.tableDataCount = data.data.count
        } else {
          this.$layer.msg('获取实验信息失败！')
        }
      }).catch(() => {
        this.$layer.msg('获取实验信息失败！')
      })
    },
    // 搜索学校
    async searchSchool(province, category) {
      if (!province) {
        if (category === 1) {
          this.searchSchoolData = []
          this.searchAcademyData = []
          this.queryInfo.school_id = ''
          this.queryInfo.academy_id = ''
        } else {
          this.schoolData = []
          this.academyData = []
          this.formInfo.school_id = ''
          this.formInfo.academy_id = ''
        }
      } else {
        await this.$http.get('/school/', {
          params: {
            page: 1,
            size: 1000,
            status: 1,
            province: province
          }
        }).then((data) => {
          if (category === 1) {
            this.searchSchoolData = data.results
            this.searchAcademyData = []
            this.queryInfo.school_id = ''
            this.queryInfo.academy_id = ''
          } else {
            this.schoolData = data.results
            this.academyData = []
            this.formInfo.school_id = ''
            this.formInfo.academy_id = ''
          }
        }).catch((error) => {
          console.log(error)
        })
      }
    },
    // 搜索学院
    async searchAcademy(schoolId, category) {
      if (!schoolId) {
        if (category === 1) {
          this.searchAcademyData = []
          this.queryInfo.academy_id = ''
        } else {
          this.academyData = []
          this.formInfo.academy_id = ''
        }
      } else {
        await this.$http.get('/academy/', {
          params: {
            page: 1,
            size: 1000,
            status: 1,
            school_id: schoolId
          }
        }).then((data) => {
          if (category === 1) {
            this.searchAcademyData = data.results
            this.queryInfo.academy_id = ''
          } else {
            this.academyData = data.results
            this.formInfo.academy_id = ''
          }
        }).catch((error) => {
          console.log(error)
        })
      }
    },
    // 搜索大类
    async searchCategory() {
      await this.$http.get('/subject_category/', {
        params: {
          page: 1,
          size: 1000,
          status: 1
        }
      }).then((data) => {
        this.searchCategoryData = data.results
        this.categoryData = data.results
      }).catch((error) => {
        console.log(error)
      })
    },
    async searchSubject(subjectCategoryId, categroy) {
      if (!subjectCategoryId) {
        if (categroy === 1) {
          this.searchSubjectData = []
          this.queryInfo.subject_id = ''
        } else {
          this.subjectData = []
          this.formInfo.subject_id = ''
        }
      } else {
        await this.$http.get('/subject/', {
          params: {
            page: 1,
            size: 100000,
            subject_category_id: subjectCategoryId,
            status: 1
          }
        }).then((data) => {
          if (categroy === 1) {
            this.searchSubjectData = data.results
            this.queryInfo.subject_id = ''
          } else {
            this.subjectData = data.results
            this.formInfo.subject_id = ''
          }
        }).catch((error) => {
          console.log(error)
        })
      }
    },
    // 分页
    pageCallback(data) {
      this.queryInfo.page = data
      this.search()
    },
    pageCalluser(data) {
      this.userQueryInfo.page = data
      this.getUser()
    },
    // 打开实验添加/编辑弹窗
    showAddWindow() {
      // if (parseInt(this.localUser.role) === 1) {
      //   this.formInfo.academy_id = this.localUser.academy_id
      // }
      this.classShowAddWindow = {
        visibility: 'visible'
      }
      this.formInfo.creator_id = this.localUser.profile_id
      this.formInfo.auth_exp_level = 4
    },
    // 关闭实验添加/编辑弹窗
    hideAddWindow() {
      this.classShowAddWindow = {}
      // this.formInfo.province = ''
      // this.formInfo.school_id = ''
      // this.formInfo.academy_id = ''

      if ([2, 10].indexOf(this.localUser.role) >= 0) {
        this.formInfo.school_id = ''
        this.formInfo.academy_id = ''
      }
      if ([3].indexOf(this.localUser.role) >= 0) {
        this.formInfo.academy_id = ''
      }
      this.formInfo.subject_category_id = ''
      this.formInfo.subject_id = ''
      this.formInfo.title = ''
    },
    // 保存
    async saveInfo() {
      if (!this.formInfo.title) {
        this.$parent.showMsg('请输入实验名称!')
        return false
      }
      if (!parseInt(this.formInfo.exp_level)) {
        this.$parent.showMsg('请选择申报级别!')
        return false
      }
      if (this.formInfo.province === '') {
        this.$parent.showMsg('请选择省份!')
        return false
      }
      if (!parseInt(this.formInfo.school_id)) {
        this.$parent.showMsg('请选择学校!')
        return false
      }
      // if (!parseInt(this.formInfo.academy_id)) {
      //   this.formInfo.academy_id = null
      // }
      if (!parseInt(this.formInfo.academy_id)) {
        this.$parent.showMsg('请选择学院!')
        return false
      }
      if (!parseInt(this.formInfo.subject_category_id)) {
        this.$parent.showMsg('请选择专业大类!')
        return false
      }
      if (!parseInt(this.formInfo.subject_id)) {
        this.$parent.showMsg('请选择专业!')
        return false
      }
      // if (parseInt(this.formInfo.exp_level) === 2) {
      //   this.formInfo.school_id = null
      //   this.formInfo.academy_id = null
      // } else if (parseInt(this.formInfo.exp_level) === 3) {
      //   this.formInfo.academy_id = null
      // }
      // if (!this.formInfo.school_id) {
      //   this.formInfo.school_id = null
      // }
      // if (!this.formInfo.academy_id) {
      //   this.formInfo.academy_id = null
      // }
      if (this.formInfo.id) {
        const url = '/experiment/' + this.formInfo.id + '/'
        await this.$http.put(url, this.formInfo).then((data) => {
          if (data.id) {
            this.$parent.showMsg('修改成功！')
            this.hideAddWindow()
            this.search()
          } else {
            this.$parent.$parent.showMsg('修改失败！')
          }
        }).catch((error) => {
          console.log(error)
          this.$parent.showMsg('修改失败！')
        })
      } else {
        await this.$http.post('/experiment/', this.formInfo).then((data) => {
          if (data.id) {
            this.$parent.showMsg('添加成功！')
            this.hideAddWindow()
            this.search()
          } else {
            this.$parent.showMsg('添加失败！')
          }
        }).catch((error) => {
          console.log(error)
          this.$parent.showMsg('添加失败！')
        })
      }
    },
    async examineBtn() {
      const url = '/experiment/' + this.examineInfo.id + '/'
      await this.$http.put(url, {
        status: this.examineInfo.status
      }).then((data) => {
        if (data.id) {
          this.$layer.msg('审核成功！')
          this.search()
          this.classShowExamineWindow = {}
        } else {
          this.$layer.msg('审核失败！')
        }
      }).catch((error) => {
        console.log(error)
        this.$layer.msg('审核失败！')
      })
    },
    // 打开负责人弹窗
    async showPersonWindow(item) {
      this.userData = []
      this.userDataCount = 0
      this.userQueryInfo.page = 1
      this.userQueryInfo.name = ''
      this.userQueryInfo.username = ''
      this.userQueryInfo.school_id = item.school_id
      this.selectedExperiment = item
      this.classShowPersonWindow = {
        display: 'block'
      }
      await this.getUser()
    },
    // 查询负责人
    async getUser() {
      await this.$http.get('/userprofile/', {
        params: this.userQueryInfo
      }).then((data) => {
        this.userData = data.results
        this.userDataCount = data.count
      }).catch(() => {
        this.$layer.msg('获取人员列表失败！')
      })
    },
    // 关闭负责人弹窗
    hidePersonWindow() {
      this.classShowPersonWindow = {
        display: 'none'
      }
    },
    // 查询选择的用户是否是负责人
    async setMaster(id) {
      this.$http.post('/experiment_set_master/', {
        exp_id: this.selectedExperiment.id,
        profile_id: id
      }).then((data) => {
        if (data.code === '200') {
          this.hidePersonWindow()
          this.search()
        } else {
          this.$layer.msg(data.msg)
        }
      })
    },
    // 编辑时查询
    async querySingle(id) {
      const url = '/experiment/' + id + '/'
      await this.$http.get(url).then(async (data) => {
        this.classShowAddWindow = {
          visibility: 'visible'
        }
        this.formInfo.id = data.id
        this.formInfo.title = data.title
        this.formInfo.exp_level = data.exp_level
        this.formInfo.province = data.province ? data.province : ''
        await this.searchSchool(this.formInfo.province)
        this.formInfo.school_id = data.school_id ? data.school_id : ''
        await this.searchAcademy(this.formInfo.school_id)
        this.formInfo.academy_id = data.academy_id ? data.academy_id : ''
        this.formInfo.subject_category_id = data.subject && data.subject.subject_category_id ? data.subject.subject_category_id : ''
        await this.searchSubject(this.formInfo.subject_category_id)
        this.formInfo.subject_id = data.subject_id ? data.subject_id : ''
        this.formInfo.apply_year = data.apply_year
        this.formInfo.auth_exp_level = data.auth_exp_level
      }).catch((error) => {
        console.log(error)
        this.$parent.showMsg('数据获取失败！')
      })
    },
    // 删除
    async askDel(id) {
      const url = '/experiment/' + id + '/'
      await this.$parent.showConfirm('确认删除此条数据吗?', () => {
        this.$http.put(url, {
          isdel: 1
        }).then((data) => {
          this.$parent.showMsg('删除成功！')
          this.search()
        }).catch((error) => {
          console.log(error)
          this.$parent.showMsg('删除失败！')
        })
      })
    },
    async Editable(id) {
      const url = '/experiment/' + id + '/'
      await this.$parent.showConfirm('是否确认返回负责人编辑?', () => {
        this.$http.put(url, {
          status: 1
        }).then((data) => {
          this.$parent.showMsg('设置成功！')
          this.search()
        }).catch((error) => {
          console.log(error)
          this.$parent.showMsg('设置失败！')
        })
      })
    },
    getCurrentTime() {
      const yy = new Date().getFullYear()
      const mm = new Date().getMonth() + 1
      const dd = new Date().getDate()
      const hh = new Date().getHours()
      const mf = new Date().getMinutes() < 10 ? '0' + new Date().getMinutes() : new Date().getMinutes()
      const ss = new Date().getSeconds() < 10 ? '0' + new Date().getSeconds() : new Date().getSeconds()
      return yy + '-' + mm + '-' + dd + 'T' + hh + ':' + mf + ':' + ss
    },
    // 发布
    async askRelease(item) {
      const url = '/experiment_pub/'
      let tips = ''
      let data = {}
      if (item.status === 8) {
        tips = '确认发布吗？'
        data = {
          id: item.id,
          status: 9,
          pubDate: this.getCurrentTime()
        }
      } else if (item.status === 9) {
        tips = '确认取消发布吗？'
        data = {
          id: item.id,
          status: 8,
          pubDate: null
        }
      }
      await this.$parent.showConfirm(tips, () => {
        this.$http.post(url, data).then((data) => {
          this.$parent.showMsg('操作成功！')
          this.search()
        }).catch((error) => {
          console.log(error)
          this.$parent.showMsg('操作失败！')
        })
      })
    },
    // 审核
    showExamineWindow(id, status) {
      debugger
      this.examineInfo.id = id
      this.examineInfo.current_status = status
      // if ([2, 4, 6].indexOf(status) >= 0) {
      //   this.examineInfo.status = status + 2
      // }
      // if ([5, 7].indexOf(status) >= 0) {
      //   this.examineInfo.status = status - 1
      // }
      if (this.examineInfo.current_status === 6) {
        this.examineInfo.status = 8
      } else if (this.examineInfo.current_status === 4 || this.examineInfo.current_status === 7) {
        this.examineInfo.status = 8
      } else if (this.examineInfo.current_status === 2 || this.examineInfo.current_status === 5) {
        if (this.platform_level === 3) {
          // 校级
          this.examineInfo.status = 4
        } else {
          // 院系级
          this.examineInfo.status = 8
        }
      }
      this.classShowExamineWindow = {
        visibility: 'visible'
      }
    },
    // 设置级别
    async saveLevel() {
      if (!this.formInfo.exp_level) {
        this.$parent.showMsg('请选择申报级别!')
        return false
      }
      const url = '/experiment/' + this.formInfo.id + '/'
      await this.$http.put(url, {
        exp_level: this.formInfo.exp_level
      }).then((data) => {
        if (data.id) {
          this.$parent.showMsg('修改成功！')
          this.classShowLevelWindow = {}
          this.search()
        } else {
          this.$parent.$parent.showMsg('修改失败！')
        }
      }).catch((error) => {
        console.log(error)
        this.$parent.showMsg('修改失败！')
      })
    },
    // 设置有效链接
    // 打开上传弹窗
    showUploadWindow() {
      this.classShowUploadWindow = {
        visibility: 'visible'
      }
    },
    // 关闭上传弹窗
    hideUploadWindow() {
      this.classShowUploadWindow = {}
    },
    async xlsChange(e) {
      const uploadUrl = '/files/' + e.target.files[0].name
      await this.$http.put(uploadUrl, e.target.files[0]).then((data) => {
        this.uploadedCsv = data
        e.srcElement.value = null
      }).catch(() => {
        this.$parent.showMsg('上传失败！')
      })
    },
    async submitCsv() {
      this.errorList = []
      const uploadUrl = '/get_excel/'
      await this.$http.get(uploadUrl, {
        params: {
          file_name: this.uploadedCsv
        }
      }).then((data) => {
        if (data.length <= 1) {
          this.$parent.showMsg('表格中无数据！')
          return
        }
        data.splice(0, 1)
        this.uploadedCscData = data
        this.hideUploadWindow()
        this.classShowProcessWindow = {
          visibility: 'visible'
        }
        this.uploadedCsv = ''
        this.isFinishUpsert = false
        this.curCsvIndex = 0
        this.csvFinishText = ''
        this.errorList = []
        this.insertOne()
      }).catch(() => {
        this.$parent.showMsg('读取失败！')
      })
    },
    async insertOne() {
      if (this.curCsvIndex >= this.uploadedCscData.length) {
        this.csvFinishText = '上传完成'
        this.isFinishUpsert = true
        this.search()
        return
      }

      const row = this.uploadedCscData[this.curCsvIndex]
      // const academy = this.academyData.map(item => item.title)
      // const userData = this.tableData.map(item => item.username)
      // let usernameValid = false
      // let province = '', school = ''
      // region 数据检查开始

      console.log(row)

      if (row[0].toString().trim().length === 0) {
        this.errorList.push({ code: 0, text: '第[' + (this.curCsvIndex + 1) + ']行[' + row[0] + ']' + '请输入实验ID！' })
        this.curCsvIndex++
        await this.insertOne()
        return
      }

      // if (!isNaN(row[0])) {
      //   this.errorList.push({ code: 0, text: '第[' + (this.curCsvIndex + 1) + ']行[' + row[0] + ']' + '实验ID必须是数字！' })
      //   this.curCsvIndex++
      //   await this.insertOne()
      //   return
      // }

      if (row[1].trim().length === 0) {
        this.errorList.push({ code: 0, text: '第[' + (this.curCsvIndex + 1) + ']行[' + row[1] + ']' + '请输入有效链接！' })
        this.curCsvIndex++
        await this.insertOne()
        return
      }

      let expInfo = null
      await this.$http.get('/experiment/' + row[0].toString().trim() + '/').then((data) => {
        expInfo = data
      }).catch((error) => {
        console.log(error)
      })

      console.log(expInfo)
      if (!expInfo) {
        this.errorList.push({ code: 0, text: '第[' + (this.curCsvIndex + 1) + ']行[' + row[0] + ']' + '实验ID不存在！' })
        this.curCsvIndex++
        await this.insertOne()
        return
      }

      console.log(123)

      // endregion 数据检查结束

      await this.$http.put('/experiment/' + row[0].toString().trim() + '/', {
        url: row[1]
      }).then((profileData) => {
        this.errorList.push({ code: 1, text: '第[' + (this.curCsvIndex + 1) + ']行[' + row[0] + ']' + '修改有效链接成功！' })
        this.curCsvIndex++
        this.insertOne()
      }).catch((error) => {
        console.log(error)
        this.errorList.push({ code: 0, text: '第[' + (this.curCsvIndex + 1) + ']行[' + row[0] + ']' + error.response.data[0] })
        this.curCsvIndex++
        this.insertOne()
      })
    }
  },
  async mounted () {
  },
  async created() {
    await this.checkAuditOpen()
    if ([2, 10].indexOf(this.localUser.role) >= 0) {
      await this.searchSchool(this.localUser.province, 1)
      // this.queryInfo.exp_level = '2,3,4'
      this.queryInfo.province = this.localUser.province

      await this.searchSchool(this.localUser.province)
      this.formInfo.province = this.localUser.province
      // this.formInfo.exp_level = 2
    }
    if ([3].indexOf(this.localUser.role) >= 0) {
      await this.searchSchool(this.localUser.province, 1)
      await this.searchAcademy(this.localUser.school_id, 1)
      // this.queryInfo.exp_level = '3,4'
      this.queryInfo.province = this.localUser.province
      this.queryInfo.school_id = this.localUser.school_id

      await this.searchSchool(this.localUser.province)
      await this.searchAcademy(this.localUser.school_id)
      this.formInfo.province = this.localUser.province
      this.formInfo.school_id = this.localUser.school_id
      // this.formInfo.exp_level = 3
    }
    if ([4, 11, 12].indexOf(this.localUser.role) >= 0) {
      await this.searchSchool(this.localUser.province, 1)
      await this.searchAcademy(this.localUser.school_id, 1)
      // this.queryInfo.exp_level = '4'
      this.queryInfo.province = this.localUser.province
      this.queryInfo.school_id = this.localUser.school_id
      this.queryInfo.academy_id = this.localUser.academy_id

      await this.searchSchool(this.localUser.province)
      await this.searchAcademy(this.localUser.school_id)
      this.formInfo.province = this.localUser.province
      this.formInfo.school_id = this.localUser.school_id
      this.formInfo.academy_id = this.localUser.academy_id
      // this.formInfo.exp_level = 4
    }
    await this.searchCategory()
    await this.search()
  },
  // 计算属性
  computed: {
    pageInfo() {
      return {
        page: this.queryInfo.page,
        all: Math.ceil(this.tableDataCount / this.queryInfo.size),
        totalData: this.tableDataCount
      }
    },
    useInfo() {
      return {
        page: this.userQueryInfo.page,
        all: Math.ceil(this.userDataCount / this.userQueryInfo.size),
        totalData: this.userDataCount
      }
    },
    localUser() {
      return this.$store.state.userInfo
    },
    isSuper() {
      if (this.$store.state.platform_level === 3) {
        return this.$store.state.userInfo.role === 3 || this.$store.state.userInfo.role === 0
      }
      if (this.$store.state.platform_level === 4) {
        return this.$store.state.userInfo.role === 4 || this.$store.state.userInfo.role === 0
      }
      return this.$store.state.userInfo.role === 0
    },

    provinceData() {
      return this.$store.state.dict_province
    },
    expLevelData() {
      return this.$store.state.dict_exp_level
    },
    authExpLevelData() {
      return this.$store.state.dict_auth_exp_level
    },
    auditExpLevel () {
      if (this.examineInfo.current_status === 4 || this.examineInfo.current_status === 7) {
        return [
          { name: '通过', value: 8 },
          { name: '不通过', value: 5 }
        ]
      } else if (this.examineInfo.current_status === 2 || this.examineInfo.current_status === 5) {
        if (this.platform_level === 3) {
          // 校级
          return [
            { name: '通过', value: 4 },
            { name: '不通过', value: 3 }
          ]
        } else {
          // 院系级
          return [
            { name: '通过', value: 8 },
            { name: '不通过', value: 3 }
          ]
        }
      }
      return []
    },
    experimentStateDict() {
      if (this.$store.state.platform_level === 3) {
        return {
          1: '填报中',
          2: '待学院审核',
          3: '学院审核未通过',
          4: '待学校审核',
          5: '学校审核未通过',
          8: '已通过审核',
          9: '已发布'
        }
      } else if (this.$store.state.platform_level === 4) {
        return {
          1: '填报中',
          2: '待学院审核',
          3: '学院审核未通过',
          8: '已通过审核',
          9: '已发布'
        }
      } else {
        return this.$store.state.dict_experiment_state
      }
    },
    sbStateDict() {
      return this.$store.state.sb_state
    },
    yearData() {
      const year = []
      for (let i = new Date().getFullYear(); i >= 2017; i--) {
        year.push(i)
      }
      return year
    },

    platform_level() {
      return this.$store.state.platform_level
    }
  }
}
</script>

<style scoped src="@/assets/css/project-detail.css"></style>

<style lang="less" scoped>
#searchSection .export-btn {
  background: orange;
}
#searchSection .mod-btn {
  background: lightgray;
}
#list td .color1 {
  color: orange;
}
#list td .color2 {
  color: rgb(0, 68, 255);
}
.search-line-btn {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.year-list {
  flex: 1;
  margin-bottom: 20px;
  li {
    display: inline-block;
    background: #eee;
    border: 1px solid #dddada;
    border-right: none;
    height: 30px;
    line-height: 30px;
    width: 40px;
    text-align: center;
    cursor: pointer;
    &:last-child {
      border-right: 1px solid #dddada;
    }
    &.active {
      background: #73D6CA;
      color: #fff;
      border: 1px solid #73D6CA;
    }
  }
}
.form_content .divLabel {
  margin-left: 0px;
}
</style>
